import script from "./AppointmentSurveySavedForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentSurveySavedForm.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentSurveySavedForm.vue?vue&type=style&index=0&id=40425927&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40425927"]])

export default __exports__